import { notification } from 'antd'

export const openNotification = (type, message, description) => {
  notification[type]({
    message: message,
    description: description,
  })
}

export const normalizeStr = str => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
}

const createKeywords = part => {
  const arrName = [];
  let curName = '';
  part.split('').forEach(letter => {
    curName += letter;
    arrName.push(curName);
  });
  return arrName;
}

export const generateKeywords = title => {
  let result = []
  const str = normalizeStr(title)
  const array = str.split(' ')
  array.forEach(part => {
    const keys = createKeywords(part)
    result.push(...keys)
  })
  result.push(...createKeywords(str))
  return result
}